var _a, _b, _c;
export var HEADER_TENANTID_KEY = 'x-tenant-id';
export var HEADER_TENANTID_IDENTIFIER = 'tenantId';
export var HEADER_TENANTID_IDENTITY = 'Tenant';
export var HEADER_USERID_KEY = 'x-user-id';
export var HEADER_USERID_IDENTIFIER = 'userId';
export var HEADER_USERID_IDENTITY = 'User';
export var HEADER_USERTOKEN_KEY = 'x-user-token';
export var HEADER_USERTOKEN_IDENTIFIER = 'userToken';
export var HEADER_USERTOKEN_IDENTITY = 'UserToken';
export var HEADER_ORGANIZATIONID_KEY = 'x-organization-id';
export var HEADER_ORGANIZATIONID_IDENTIFIER = 'organizationId';
export var HEADER_ORGANIZATIONID_IDENTITY = 'Organization';
export var HEADER_LANGUAGE_KEY = 'x-language';
export var HEADER_LANGUAGE_IDENTIFIER = 'language';
export var HEADER_LANGUAGE_IDENTITY = 'Language';
export var HeadersKeyToIdentifierMap = (_a = {},
    _a[HEADER_TENANTID_KEY] = HEADER_TENANTID_IDENTIFIER,
    _a[HEADER_USERID_KEY] = HEADER_USERID_IDENTIFIER,
    _a[HEADER_USERTOKEN_KEY] = HEADER_USERTOKEN_IDENTIFIER,
    _a[HEADER_ORGANIZATIONID_KEY] = HEADER_ORGANIZATIONID_IDENTIFIER,
    _a[HEADER_LANGUAGE_KEY] = HEADER_LANGUAGE_IDENTIFIER,
    _a);
export var HeadersIdentifierToKeyMap = (_b = {},
    _b[HEADER_TENANTID_IDENTIFIER] = HEADER_TENANTID_KEY,
    _b[HEADER_USERID_IDENTIFIER] = HEADER_USERID_KEY,
    _b[HEADER_USERTOKEN_IDENTIFIER] = HEADER_USERTOKEN_KEY,
    _b[HEADER_ORGANIZATIONID_IDENTIFIER] = HEADER_ORGANIZATIONID_KEY,
    _b[HEADER_LANGUAGE_IDENTIFIER] = HEADER_LANGUAGE_KEY,
    _b);
export var Context = (_c = {},
    _c[HEADER_TENANTID_IDENTITY] = {
        key: HEADER_TENANTID_KEY,
        id: HEADER_TENANTID_IDENTIFIER,
    },
    _c[HEADER_USERID_IDENTITY] = {
        key: HEADER_USERID_KEY,
        id: HEADER_USERID_IDENTIFIER,
    },
    _c[HEADER_USERTOKEN_IDENTITY] = {
        key: HEADER_USERTOKEN_KEY,
        id: HEADER_USERTOKEN_IDENTIFIER,
    },
    _c[HEADER_ORGANIZATIONID_IDENTITY] = {
        key: HEADER_ORGANIZATIONID_KEY,
        id: HEADER_ORGANIZATIONID_IDENTIFIER,
    },
    _c[HEADER_LANGUAGE_IDENTITY] = {
        key: HEADER_LANGUAGE_KEY,
        id: HEADER_LANGUAGE_IDENTIFIER,
    },
    _c);
